<template>
  <section class="list-container">
    <SequenceCard create @create="handleShowCreate" />

    <SequenceCard
      v-for="sequence in sequences"
      :key="sequence.id"
      :create="false"
      :sequence="sequence"
      @update="emit('update')"
    />
  </section>

  <CreateSequenceModal v-if="openCreateModal" v-model:open="openCreateModal" />

  <RestrictionChangePlanModal
    title="Realiza un upgrade y accede a todo el poder de Beex."
    v-model:open="openRestriction"
    :plan-request="PlanType.AllInOne"
  >
    <template #description>
      Tu plan {{ PlanTypeText[plan as PlanType] }} no incluye este módulo.
      Solicita un upgrade tu plan para potenciar tu ambiente de trabajo.
    </template>
  </RestrictionChangePlanModal>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from "vue";

import { Sequence } from "@/@types/flows/sequences";

import SequenceCard from "@/app/flows/sequences/components/cards/SequenceCard.vue";
import CreateSequenceModal from "@/app/flows/sequences/components/modals/CreateSequenceModal.vue";
import { PlanType, PlanTypeText } from "@/app/common/types";
import { useStore } from "vuex";
import RestrictionChangePlanModal from "@/app/common/components/modals/RestrictionChangePlanModal.vue";
import { ActionPlanStrategy } from "@/app/common/utils/enums";
import { watch } from "vue";
import EventBus from "@/app/shared/utils/eventBus";

defineProps<{ sequences: Sequence[] }>();

const emit = defineEmits<{ update: [] }>();

const store = useStore();

const user = computed(() => store.getters["getDataUser"]);
const plan = computed(() => user.value?.change_custom_plan?.plan);
const openRestriction = ref(false);

watch(user, () => {
  validateActionPlanHeader();
})

watch(plan, () => {
  validateActionPlanHeader();
})

const openCreateModal = ref(false);
const PlanEspecial = 5;

const validateActionPlanHeader = () => {
  if (![PlanType.AllInOne, PlanEspecial].includes(plan.value)) {
    store.commit("SET_ACTION_PLAN_HEADER", ActionPlanStrategy.Upgrade);
  } else {
    store.commit("SET_ACTION_PLAN_HEADER", null);
  }
};

const handleShowCreate = () => {
  if (![PlanType.AllInOne, PlanEspecial].includes(plan.value))
    openRestriction.value = true
  else
    openCreateModal.value = true
}

EventBus.on("SHOW_RESTRICTION_PLAN", () => {
  openRestriction.value = true
});

onMounted(() => {
  validateActionPlanHeader();
});

onUnmounted(() => {
  store.commit("SET_ACTION_PLAN_HEADER", null);
});
</script>

<style scoped lang="sass">
.list-container
  gap: 12px
  display: grid
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr))
</style>
